import { Component } from '@angular/core';

import { UserService } from '@services/user.service';
import { LanguageService } from '@services/language.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.css']
})
export class SidenavComponent {
  public navList = [
    {
      link: 'dashboard',
      icon: 'home',
      iconActive: 'home-solid',
      name: 'home'
    },
    {
      link: 'beneficiary',
      icon: 'beneficiary',
      iconActive: 'beneficiary-solid',
      name: 'beneficiary'
    },
    {
      link: '/history',
      icon: 'history',
      iconActive: 'history-solid',
      name: 'history'
    },
    {
      link: '/account',
      icon: 'account',
      iconActive: 'account-solid',
      name: 'account'
    }
  ];
  protected showMultiLanguage: boolean = false;

  protected readonly switchLanguage = (lang: string) => {
    this.languageService.onSetLanguage(lang);
    this.showMultiLanguage = !this.showMultiLanguage;
  };

  constructor(
    private userService: UserService,
    protected readonly languageService: LanguageService
  ) {}

  logout(): void {
    this.userService.logout().subscribe();
  }
}
